import { FGM } from "../brand";

export default function Manifesto() {
    return (
        <section
            id="manifesto"
            data-testid="manifesto-section"
            className="relative bg-fgm-dark py-16 md:py-24 overflow-hidden"
        >
            {/* Watermark eagle */}
            <img
                src={FGM.logos.gray}
                alt=""
                aria-hidden
                className="absolute -right-24 top-1/2 -translate-y-1/2 w-[680px] opacity-[0.04] pointer-events-none select-none"
             loading="lazy" decoding="async" />

            <div className="relative max-w-7xl mx-auto px-6 md:px-10">
                <div className="flex items-center gap-4 mb-12">
                    <span className="h-px w-12 bg-[#E63946]" />
                    <span className="font-display tracking-[0.35em] text-zinc-400 text-sm uppercase">
                        / 01 — The Manifesto
                    </span>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                    {/* Left — Massive stacked words */}
                    <div data-testid="manifesto-title" className="lg:col-span-7">
                        <div className="font-display leading-[0.85] uppercase tracking-tight">
                            <div className="text-white text-[18vw] md:text-[14vw] lg:text-[12.5rem]">
                                Focus<span className="text-[#E63946]">.</span>
                            </div>
                            <div className="font-outline-strong text-[18vw] md:text-[14vw] lg:text-[12.5rem] -mt-4 md:-mt-6">
                                Grind.
                            </div>
                            <div className="text-white text-[18vw] md:text-[14vw] lg:text-[12.5rem] -mt-4 md:-mt-6">
                                Motivate<span className="text-[#1D4ED8]">.</span>
                            </div>
                        </div>
                    </div>

                    {/* Right — Editorial text */}
                    <div data-testid="manifesto-text" className="lg:col-span-5 lg:pt-12">
                        <div className="fgm-stripe-divider w-16 mb-6" />
                        <p className="text-zinc-300 text-lg md:text-xl font-body leading-relaxed mb-6">
                            FGM Apparel is more than clothing —{" "}
                            <span className="text-white">
                                it's a mindset built for the relentless.
                            </span>
                        </p>
                        <p className="text-zinc-400 font-body leading-relaxed mb-6">
                            Designed for athletes, creators, runners, bikers, and
                            those who move with purpose, FGM represents discipline,
                            ambition, and self-motivation. Every piece is created to
                            inspire confidence, hustle, and individuality while
                            blending streetwear culture with performance-driven
                            energy.
                        </p>
                        <p className="text-zinc-400 font-body leading-relaxed mb-10">
                            Rooted in strength and elevated by modern design, the
                            FGM bird logo symbolizes freedom, focus, and the hunger
                            to rise above limits.
                        </p>

                        <ul className="space-y-4">
                            {[
                                ["F", "Focus on the vision.", "#E63946"],
                                ["G", "Grind through the struggle.", "#FFFFFF"],
                                ["M", "Motivate the world.", "#1D4ED8"],
                            ].map(([letter, line, color], i) => (
                                <li
                                    key={i}
                                    data-testid={`manifesto-pillar-${i}`}
                                    className="flex items-baseline gap-5 border-t border-white/10 pt-4"
                                >
                                    <span
                                        className="font-display text-4xl md:text-5xl shrink-0"
                                        style={{ color }}
                                    >
                                        {letter}
                                    </span>
                                    <span className="font-display text-2xl md:text-3xl text-white uppercase tracking-wide">
                                        {line}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
